<template>
  <div>
    <HeaderPage
      pageTitle="Novo Cliente"
      pageSubTitle="Cadastre novos clientes para nosso serviço"
    />

    <v-card class="pa-5">
      <v-layout column>
        <v-form ref="form" v-model="valid" lazy-validation>
          <h6 class="subheading font-weight-medium">Cliente</h6>
          <v-divider></v-divider>
          <v-layout column class="pa-3">
            <v-layout>
              <v-flex xs12>
                <v-checkbox
                  v-model="object.client.isDeveloperClient"
                  label="Cliente para uso da T.I?"
                >
                </v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12 md3>
                <v-text-field
                  v-model="object.client.name"
                  label="Nome"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex class="pl-3" column>
                <span class="body-1">Termo de uso:</span>
                <v-flex xs12 md4>
                  <input type="file" @change="uploadFile($event)" />
                </v-flex>
              </v-flex>

              <v-flex xs12 md3>
                <v-select
                  v-model="object.client.type_client"
                  :items="typesOfClients"
                  item-value="value"
                  item-text="text"
                  label="Tipo de Cliente"
                  class="mr-2"
                  required
                ></v-select>
              </v-flex>
              <v-flex xs12 md3>
                <v-dialog
                  ref="dialog_mobilization_date"
                  v-model="mobilization_date"
                  :return-value.sync="object.client.mobilization_date"
                  persistent
                  lazy
                  max-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="object.client.mobilization_date"
                      label="Previsão de mobilização"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>

                  <v-date-picker
                    v-model="object.client.mobilization_date"
                    scrollable
                    class="color"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      flat
                      color="primary"
                      @click="mobilization_date = false"
                      >Cancelar</v-btn
                    >
                    <v-btn
                      flat
                      color="primary"
                      @click="
                        $refs.dialog_mobilization_date.save(
                          object.client.mobilization_date
                        )
                      "
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex xs12 md3>
                <v-text-field
                  v-model="object.client.phone_client"
                  label="Telefone do Cliente"
                  v-mask="'(##)#####-####'"
                  class="mr-2"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 md3>
                <v-text-field
                  v-model="object.client.email_client"
                  label="E-mail do Cliente"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 md3 class="ml-2">
                <v-row>
                  <v-col cols="5">
                    <v-text-field
                      v-model="object.client.initial_age_group"
                      label="Faixa etária inicial"
                      type="number"
                      min="18"
                      max="99"
                      :counter="2"
                      maxlength="2"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="1" class="d-flex justify-center align-center">
                    <span>até</span>
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      v-model="object.client.final_age_group"
                      label="Faixa etária final"
                      type="number"
                      min="18"
                      max="99"
                      :counter="2"
                      maxlength="2"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-flex>
            </v-layout>
          </v-layout>

          <h6 class="subheading font-weight-medium">Administrador</h6>
          <v-divider></v-divider>
          <v-layout class="pa-3" column>
            <v-layout>
              <v-flex xs12 md3>
                <v-text-field
                  v-model="object.client.name_adm"
                  label="Nome"
                  class="mr-2"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 md3>
                <v-text-field
                  v-model="object.client.phone"
                  label="Celular"
                  v-mask="'(##)#####-####'"
                  class="mr-2"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 md3>
                <v-text-field
                  v-mask="'###.###.###-##'"
                  v-model="object.client.cpf"
                  label="CPF"
                  :rules="[v => !!v || 'Campo obrigatório!']"
                  class="mr-2"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 md3>
                <v-text-field
                  v-model="object.client.email"
                  label="E-mail"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-layout>

          <h6 class="subheading font-weight-medium">Endereço</h6>
          <v-divider></v-divider>
          <v-layout class="pa-3" column>
            <div class="form-group form-row">
              <div class="col-md-12 col-lg-12 pt-2">
                <vue-google-autocomplete
                  id="clientAddress"
                  class="form-control"
                  placeholder="Digite o endereço"
                  v-model="object.address.address_formatted"
                  v-on:placechanged="setAddress"
                  country="br"
                ></vue-google-autocomplete>
              </div>
            </div>

            <v-layout>
              <v-flex xs12 md4>
                <v-text-field
                  v-model="object.address.street"
                  label="Rua"
                  class="mr-2"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 md4>
                <v-text-field
                  v-model="object.address.number"
                  label="Número"
                  class="mr-2"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 md4>
                <v-text-field
                  v-mask="'##.###-###'"
                  v-model="object.address.zip"
                  label="CEP"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex xs12 md4>
                <v-text-field
                  v-model="object.address.neighborhood"
                  label="Bairro"
                  class="mr-2"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 md4>
                <v-text-field
                  v-model="object.address.city"
                  label="Cidade"
                  class="mr-2"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 md4>
                <v-text-field
                  v-mask="'AA'"
                  v-model="object.address.state"
                  label="Estado"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex xs12 md4>
                <v-text-field
                  v-model="object.address.latitude"
                  label="Latitude"
                  class="mr-2"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 md4>
                <v-text-field
                  v-model="object.address.longitude"
                  label="Longitude"
                  class="mr-2"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 md4>
                <v-select
                  :items="rotation"
                  item-value="value"
                  item-text="text"
                  v-model="object.address.rotation_id"
                  label="Rodízio de Placas"
                  required
                ></v-select>
              </v-flex>
            </v-layout>
          </v-layout>

          <h6 class="subheading font-weight-medium">Veículo</h6>
          <v-divider></v-divider>
          <v-layout column class="pa-3">
            <v-layout>
              <v-flex xs12>
                <v-checkbox
                  v-model="object.vehicles[0].isFakeVehicleOrInternal"
                  label="Veículo FAKE ou de USO INTERNO (Marque essa opção caso o veículo seja apenas para cadastrar o cliente)"
                >
                </v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12 md3>
                <v-dialog
                  ref="dialog_begin"
                  v-model="fleet_start_date"
                  :return-value.sync="object.vehicles[0].fleet_start_date"
                  persistent
                  lazy
                  max-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="object.vehicles[0].fleet_start_date"
                      label="Data início do contrato de locação"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>

                  <v-date-picker
                    v-model="object.vehicles[0].fleet_start_date"
                    scrollable
                    class="color"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      flat
                      color="primary"
                      @click="fleet_start_date = false"
                      >Cancelar</v-btn
                    >
                    <v-btn
                      flat
                      color="primary"
                      @click="
                        $refs.dialog_begin.save(
                          object.vehicles[0].fleet_start_date
                        )
                      "
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12 md4>
                <v-text-field
                  v-mask="'AAA-#X##'"
                  v-model="object.vehicles[0].plate"
                  label="Placa"
                  :rules="[
                    v => !!v || 'Campo obrigatório!',
                    v => validPlate(v) || 'Placa ativa ou já registrada',
                  ]"
                  class="mr-2"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 md4>
                <v-text-field
                  label="Hodômetro do veículo (KM)"
                  v-mask="'#########'"
                  class="mr-2"
                  v-model="object.vehicles[0].odometer_adjustment"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 md4>
                <v-select
                  v-model="modelSelected"
                  :items="models"
                  item-text="model"
                  return-object
                  label="Modelo"
                  class="mr-2"
                  required
                ></v-select>
              </v-flex>

              <v-flex xs12 md4>
                <v-select
                  v-model="object.vehicles[0].vehicle_category_id"
                  :items="category"
                  item-text="name"
                  item-value="id"
                  label="Categoria"
                  @change="getPromotionsByCategory"
                  required
                ></v-select>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex xs12 md3 class="mr-2">
                <label for="model">Valor Hora</label>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span
                      class="input-group-text font-weight-medium"
                      id="basic-addon1"
                      >R$</span
                    >
                  </div>
                  <money
                    v-model="object.vehicles[0].price_hour"
                    v-bind="money"
                    class="form-control"
                  ></money>
                </div>
              </v-flex>

              <v-flex xs12 md3 class="mr-2">
                <label for="model">Valor KM</label>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span
                      class="input-group-text font-weight-medium"
                      id="basic-addon1"
                      >R$</span
                    >
                  </div>
                  <money
                    v-model="object.vehicles[0].price_km"
                    v-bind="money"
                    class="form-control"
                  ></money>
                </div>
              </v-flex>

              <v-flex xs12 md3 class="mr-2">
                <label for="model">Valor Pré Autorização</label>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span
                      class="input-group-text font-weight-medium"
                      id="basic-addon1"
                      >R$</span
                    >
                  </div>
                  <money
                    v-model="object.vehicles[0].pre_authorization_value"
                    v-bind="money"
                    class="form-control"
                  ></money>
                </div>
              </v-flex>
              <v-flex xs12 md3>
                <label for="model">Valor Multa</label>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span
                      class="input-group-text font-weight-medium"
                      id="basic-addon1"
                      >R$</span
                    >
                  </div>
                  <money
                    v-model="object.config.client_mulct_per_hour"
                    v-bind="money"
                    class="form-control"
                  ></money>
                </div>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex xs12 md4>
                <v-select
                  v-model="object.vehicles[0].id_tracker"
                  :items="trackers"
                  item-text="name"
                  item-value="id"
                  label="Rastreador"
                  class="mr-2"
                  required
                ></v-select>
              </v-flex>

              <v-flex xs12 md4>
                <v-text-field
                  v-model="object.vehicles[0].imei"
                  label="IMEI"
                  v-mask="'###############'"
                  class="mr-2"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 md4>
                <v-select
                  v-model="object.vehicles[0].direction_type"
                  :items="directions"
                  label="Direção"
                  required
                ></v-select>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex xs12 md4>
                <v-select
                  :items="gearboxs"
                  v-model="object.vehicles[0].gearbox"
                  label="Câmbio"
                  class="mr-2"
                  required
                ></v-select>
              </v-flex>
              <v-flex xs12 md4>
                <v-select
                  :items="air_conditioning_option"
                  item-value="value"
                  item-text="text"
                  v-model="object.vehicles[0].air_conditioning"
                  label="Ar-condicionado"
                  class="mr-2"
                  required
                ></v-select>
              </v-flex>

              <v-flex xs12 md4>
                <v-text-field
                  type="number"
                  v-model="object.vehicles[0].doors_qtd"
                  label="Número de Portas"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex xs12 md4>
                <v-text-field
                  v-model="object.vehicles[0].card_number"
                  label="Número Cartão Combustível"
                  class="mr-2"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 md4>
                <v-text-field
                  v-model="object.vehicles[0].card_password"
                  label="Senha Cartão Combustível"
                  class="mr-2"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-layout>

          <v-row>
            <v-col>
              <h6 class="subheading font-weight-medium">Promoções</h6>
              <v-divider></v-divider>

              <v-layout column class="pa-3">
                <v-checkbox
                  v-model="emptyPromotions"
                  @change="selectedPromotions = []"
                  label="Esse cliente não possui promoções vinculadas"
                >
                </v-checkbox>

                <v-data-table
                  :required="!emptyPromotions"
                  v-if="!emptyPromotions"
                  :headers="promotionsHeader"
                  :items="categoryPromotions"
                  :single-select="false"
                  v-model="selectedPromotions"
                  class="elevation-1"
                  show-select
                  item-key="id"
                  :search="search"
                  :items-per-page="10"
                >
                  <template v-slot:top>
                    <v-text-field
                      v-model="search"
                      label="Procurar"
                      class="mx-4"
                    ></v-text-field>
                  </template>
                  <template v-slot:body="{ items }">
                    <tbody>
                      <tr v-for="item in items" :key="item.id">
                        <td>
                          <v-checkbox
                            v-model="selectedPromotions"
                            :value="item"
                            hide-details
                          />
                        </td>
                        <td>{{ item.name }}</td>
                        <td>{{ item.type | typeFilter }}</td>

                        <td
                          v-if="
                            item.promotion_vehicle_model.length == 0 &&
                              item.promotion_client.length > 0
                          "
                        >
                          R${{
                            item.promotion_client[0].activation_value | money
                          }}
                        </td>

                        <td v-else>
                          {{
                            item.promotion_vehicle_model[0].package_value
                              | money
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-data-table>
              </v-layout>
            </v-col>
          </v-row>

          <v-divider></v-divider>

          <v-layout align-center justify-end>
            <v-btn
              large
              class="success ma-0"
              :loading="loadButton"
              @click="request()"
            >
              Cadastrar
            </v-btn>
          </v-layout>
        </v-form>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import LicensePlateRotationSchemeController from '../../controllers/LicensePlateRotationSchemeController';
import VehicleModelController from '../../controllers/VehicleModelController';
import TrackerController from '../../controllers/TrackerController';
import ClientController from '../../controllers/ClientController';
import PromotionController from '../../controllers/PromotionController';
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import VehicleCategoryController from '../../controllers/VehicleCategoryController.js';
import VehicleController from '../../controllers/VehicleController.js';
import { ValidateCPF } from '../../helpers/Validators';
import HeaderPage from '../public/HeaderPage.vue';
export default {
  components: {
    VueGoogleAutocomplete,
    HeaderPage,
  },

  async created() {
    this.vehicleController = new VehicleController(this.$resource);
    this.vehicleCategoryController = new VehicleCategoryController(
      this.$resource
    );
    await this.getModels();
    await this.getLicensePlateRotationScheme();
    await this.getTrackers();
    this.getCategory();
    this.getVehicles();
    this.getRecurrents();
    this.defautForm = this.object;
  },
  filters: {
    money(str) {
      if (isNaN(str)) {
        return '';
      } else {
        str = 'R$ ' + parseFloat(str / 100).toFixed(2);
        return str.replace('.', ',');
      }
    },
    typeFilter(value) {
      switch (value) {
        case 'promotion':
          return 'Promoção';
        case 'package':
          return 'Pacote';
        case 'recurrent':
          return 'Recorrente';
        case 'wallet_hours':
          return 'Carteira de Horas';
      }
    },
  },

  data() {
    return {
      licensePlateRotationSchemeController: new LicensePlateRotationSchemeController(
        this.$resource
      ),
      vehicleModelController: new VehicleModelController(this.$resource),
      trackerController: new TrackerController(this.$resource),
      clientController: new ClientController(this.$resource),
      promotionController: new PromotionController(this.$resource),
      valid: true,
      category: [],
      models: [],
      vehicles: [],
      cpfs: [],
      trackers: [],
      directions: ['Hidráulica', 'Mecânica', 'Elétrica'],
      gearboxs: ['Manual', 'Automático'],
      modelSelected: null,
      mobilization_date: false,
      fleet_start_date: false,
      air_conditioning_option: [
        {
          text: 'Sim',
          value: true,
        },
        {
          text: 'Não',
          value: false,
        },
      ],
      typesOfClients: [
        // {
        //   text: 'Concessionaria',
        //   value: 'concessionaria',
        // },
        {
          text: 'Condominio',
          value: 'condominio',
        },
        // {
        //   text: 'UseCarMais',
        //   value: 'usecarmais',
        // },
        {
          text: 'Frotas',
          value: 'frotas',
        },
      ],
      object: {
        address: {
          street: '',
          number: '',
          zip: null,
          city: '',
          neighborhood: '',
          state: '',
          latitude: null,
          longitude: null,
          address_formatted: '',
          rotation_id: null,
        },
        client: {
          name: '',
          email_client: '',
          phone_client: '',
          type_client: '',
          status: true,
          show_in_register: true,
          isDeveloperClient: false,
          mobilization_date: new Date().toISOString().substr(0, 10),
          initial_age_group: '',
          final_age_group: '',
          name_adm: '',
          cpf: '',
          email: '',
          phone: '',
        },
        vehicles: [
          {
            plate: '',
            model_id: '',
            brand: '',
            renavam: 1,
            active: true,
            price_km: 0.9,
            price_hour: 12.99,
            pre_authorization_value: 100.0,
            doors_qtd: 4,
            air_conditioning: true,
            direction_type: 'Elétrica',
            gearbox: 'Manual',
            id_tracker: null,
            imei: '',
            card_number: '',
            card_password: '',
            odometer_adjustment: '',
            isFakeVehicleOrInternal: false,
            fleet_start_date: new Date().toISOString().substr(0, 10),
          },
        ],
        promotions: {
          inherit_promotions: null,
          inherit_recurrent: [],
        },
        config: {
          client_mulct_per_hour: 30,
        },
      },
      search: null,
      money: {
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: true,
      },
      file: {},
      loadButton: false,
      defautForm: {},
      rotation: [
        {
          text: 'Sem rodízio',
          value: null,
        },
      ],
      promotionsRecurrent: [],
      emptyPromotions: false,
      selectedFakeVehicle: [],
      categoryPromotions: [],
      selectedPromotions: [],
      promotionsHeader: [
        { text: 'Nome', value: 'name' },
        { text: 'Tipo', value: 'type' },
        { text: 'Valor', value: 'promotion_client.activation_value' },
      ],
    };
  },
  props: {
    show: Boolean,
  },
  methods: {
    validPlate(name) {
      if (
        this.vehicles.find(
          vehicle => vehicle.plate == name && vehicle.active == true
        )
      ) {
        return false;
      } else {
        return true;
      }
    },

    async getVehicles() {
      await this.vehicleController
        .getAllVehicles()
        .then(response => {
          this.vehicles = response;
        })
        .catch(error => {
          this.$awn.alert('Falha ao obter veículos');
        });
    },

    getModels() {
      this.vehicleModelController
        .get()
        .then(res => {
          this.models = res;
        })
        .catch(error => {
          console.log(error);
        });
    },
    async getPromotionsByCategory() {
      let category = this.object.vehicles[0].vehicle_category_id;

      await this.promotionController
        .getByCategory(category)
        .then(response => {
          this.categoryPromotions = response;
        })
        .catch(error => {
          this.$awn.alert(error);
        });
    },

    getLicensePlateRotationScheme() {
      this.licensePlateRotationSchemeController
        .getAll()
        .then(res => {
          res = res.map(scheme => ({
            text: `${scheme.state}, ${scheme.city}`,
            value: scheme.id,
          }));
          this.rotation = [...this.rotation, ...res];
        })
        .catch(error => {
          console.log(error);
        });
    },

    getCategory() {
      this.vehicleCategoryController
        .getAll()
        .then(res => (this.category = res));
    },

    getTrackers() {
      this.trackerController
        .getAllTracker()
        .then(res => {
          this.trackers = res;
        })
        .catch(error => {
          console.log(error);
        });
    },

    async getRecurrents() {
      await this.promotionController.getAllRecurrentType().then(res => {
        let promotions = res;
        promotions.map(promotion => {
          this.promotionsRecurrent.push(promotion.name);
        });
      });
    },

    realToCents(value) {
      value = value.replace(',', '');
      while (value.includes('.')) {
        value = value.replace('.', '');
      }
      return value;
    },

    format() {
      this.modelSelected
        ? (this.object.vehicles[0].model_id = this.modelSelected.id)
        : (this.object.vehicles[0].model_id = null);
      this.modelSelected
        ? (this.object.vehicles[0].brand = this.modelSelected.brand)
        : (this.object.vehicles[0].brand = null);
      this.object.address.zip = this.object.address.zip.replace(/\.|\-/gi, '');
      this.object.address.zip = parseInt(this.object.address.zip);

      this.object.config.client_mulct_per_hour = this.realToCents(
        this.object.config.client_mulct_per_hour
      );
      this.object.vehicles[0].price_km = this.realToCents(
        this.object.vehicles[0].price_km
      );
      this.object.vehicles[0].price_hour = this.realToCents(
        this.object.vehicles[0].price_hour
      );
      this.object.vehicles[0].pre_authorization_value = this.realToCents(
        this.object.vehicles[0].pre_authorization_value
      );

      this.object.vehicles[0].doors_qtd = parseInt(
        this.object.vehicles[0].doors_qtd
      );
    },

    setAddress(addressData, placeResultData, id) {
      let city = placeResultData.address_components.filter(cp => {
        let type = cp.types.filter(
          type => type === 'administrative_area_level_2'
        );
        if (type.length) return cp;
      });
      city = city[0].long_name;

      this.object.address.latitude = addressData.latitude;
      this.object.address.longitude = addressData.longitude;
      this.object.address.city = city;
      this.object.address.zip = addressData.postal_code
        ? addressData.postal_code.replace('-', '')
        : null;
      this.object.address.state = addressData.administrative_area_level_1;
      this.object.address.street = addressData.route;
      this.object.address.number = addressData.street_number;
      this.object.address.neighborhood = placeResultData.vicinity;
      this.object.address.address_formatted = placeResultData.formatted_address;
    },

    uploadFile(event) {
      this.file = event.target.files[0];
    },

    async request() {
      this.object.promotions.inherit_promotions = this.selectedPromotions;

      this.format();
      if (!this.emptyPromotions && this.selectedPromotions.length == 0) {
        this.loadButton = false;

        return this.$awn.alert('Configure as promoções!');
      }
      if (!ValidateCPF(this.object.client.cpf.replace(/\.|\-/gi, ''))) {
        return this.$awn.alert('Seu CPF está inválido!');
      }

      this.object.client.phone_client = this.object.client.phone_client.replace(
        /[^\d]/g,
        ''
      );
      this.object.client.phone = this.object.client.phone.replace(/[^\d]/g, '');

      this.loadButton = true;
      await this.clientController
        .newRegister(this.object, this.file)
        .then(res => {
          this.object = this.defautForm;
          this.file = {};
          this.loadButton = false;
          this.$awn.success('Cliente criado com sucesso.');
        })
        .catch(error => {
          console.log(error);
          this.loadButton = false;
          this.$awn.alert(error, error.message);
        });
    },
  },
};
</script>
<style scoped>
.container-principal {
  margin: 0px !important;
  min-width: none !important;
  max-width: none !important;
}

h6 {
  color: #2f5293;
}
</style>
